import Vue from 'vue'

import {
    filter as _filter,
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import QuestionModel from '@/models/QuestionModel'

import feedbackService from '@/services/feedback.service'

// -----------------------------------------------------------------------------

const state = {
    isFetching: false,
    isSending: false,
    questions: {},
}

const getters = {
    getQuestions: state => {
        return _orderBy(state.questions, ['order', 'name'], ['asc', 'asc'])
    },

    getQuestionsByDate: state => date => {
        const questions = _filter(state.questions, (item) => {
            return date >= item.dateL && date <= item.dateR
        })

        return _orderBy(questions, ['order', 'name'], ['asc', 'asc'])
    },

    getQuestion: state => questionId => {
        return state.questions[questionId] || null
    },
}

const mutations = {
    setIsFetching(state, payload) {
        state.isFetching = !!payload
    },
    setIsSending(state, payload) {
        state.isSending = !!payload
    },

    setQuestions(state, payload) {
        state.carModels = {}

        _forEach(payload, item => {
            const Question = new QuestionModel(item)

            Vue.set(state.questions, Question.id, Question)
        })
    },
}

const actions = {
    fetch({ commit }) {
        commit('setIsFetching', true)
        return new Promise((resolve, reject) => {
            feedbackService.getQuestions()
                .then(response => {
                    commit('setQuestions', response.response.items)
                    commit('setIsFetching', false)

                    resolve()
                })
                .catch(error => {
                    commit('setIsFetching', false)
                    reject(error)
                })
        })
    },

    sendAnswers({ commit }, params) {
        commit('setIsSending', true)
        return new Promise((resolve, reject) => {
            feedbackService.sendAnswers(params)
                .then(() => {
                    commit('setIsSending', false)

                    resolve()
                })
                .catch(error => {
                    commit('setIsSending', false)
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
